import React from 'react'
import { object, number } from 'prop-types'
import Table from 'react-bootstrap/lib/Table'
import { Fieldset } from 'react-gridforms'
import acc from 'accounting'

const SubjectSummary = ({ data, total }) => (
  <div className="col-sm-6">
    <form className="grid-form">
      <Fieldset legend="Subject Summary">
        <Table>
          <thead>
            <tr>
              <th width="20%">Code</th>
              <th>Description</th>
              <th width="10%" className="text-right">Lec Units</th>
              <th width="10%" className="text-right">Lab Units</th>
              <th width="10%" className="text-right">Paid Units</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, k) => (
              <tr key={k}>
                <td>{item.get('subject_code')}</td>
                <td><small>{item.get('subject_name')}</small></td>
                <td className="text-right">{acc.formatNumber(item.get('lec_units'), 1)}</td>
                <td className="text-right">{acc.formatNumber(item.get('lab_units'), 1)}</td>
                <td className="text-right">{acc.formatNumber(item.get('punits'), 1)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan="4" className="text-right">Total Paid Units:</th>
              <th className="text-right">{acc.formatNumber(total, 1)}</th>
            </tr>
          </tfoot>
        </Table>
      </Fieldset>
    </form>
  </div>
)

SubjectSummary.propTypes = {
  data: object,
  total: number,
}

export default SubjectSummary



// WEBPACK FOOTER //
// ./src/containers/Billing/subject-summary.js